export interface CutsceneOptics {
  enabled: boolean
  focusDistance: number
  sharpRange: number
  falloff: number
  maxBlur: number
}

/** Critically damped-enough focus chase for a miniature camera. The exponential form is
 * frame-rate independent and reaches the target without the one-frame focus pop caused by
 * assigning a new shot's distance directly to the shader uniform. */
export function smoothFocusDistance(current: number, target: number, deltaSeconds: number, settleRate = 14): number {
  const from = Number.isFinite(current) && current > 0 ? current : 15
  const to = Number.isFinite(target) && target > 0 ? target : 15
  if (!Number.isFinite(deltaSeconds) || deltaSeconds <= 0) return from
  const amount = 1 - Math.exp(-Math.min(deltaSeconds, 0.1) * Math.max(0, settleRate))
  return from + (to - from) * amount
}

export function cutsceneOptics(sceneName: string, distance: number): CutsceneOptics {
  return {
    enabled: sceneName === 'CutsceneDioramaScene',
    focusDistance: Number.isFinite(distance) && distance > 0 ? distance : 15,
    sharpRange: 3.2,
    falloff: 13,
    maxBlur: 0.004,
  }
}

/** CPU equivalent of the signed circle-of-confusion envelope in the combine shader. */
export function focusBlurAtDepth(depth: number, optics: CutsceneOptics): number {
  if (!optics.enabled) return 0
  return Math.min(1, Math.max(0, Math.abs(depth - optics.focusDistance) - optics.sharpRange) / optics.falloff) * optics.maxBlur
}
